export enum PORTALTYPE {
    ADMIN = 'admin',
    EMPLOYEEE = 'employee',
    COMPANY= 'company'
};